const handleDownloadClick = (): void => {
        if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            window.location.href = "https://testflight.apple.com/join/edxyCJeP";
        } else {
            window.location.href =
                "https://play.google.com/store/apps/details?id=com.lifelongcards.app";
        }
    };

const scrollToSection = (id: string): void => {
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};

const Header = () => (
    <header className="fixed top-0 left-0 w-full z-20 bg-white/95 backdrop-blur-sm shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
            <div className="text-2xl font-extrabold text-[#4F46E5] flex items-center">
                <a href="/">
                <img alt="Olakh's Logo" src="olakh.png" style={{ width: "100px" }} />
                </a>
            </div>
            <nav className="hidden md:flex space-x-8">
                <button onClick={() => scrollToSection('features')} className="text-gray-600 hover:text-indigo-600 transition duration-150 font-medium">Features</button>
                <button onClick={() => scrollToSection('security')} className="text-gray-600 hover:text-indigo-600 transition duration-150 font-medium">Security</button>
                <button onClick={() => scrollToSection('business')} className="text-gray-600 hover:text-indigo-600 transition duration-150 font-medium">Business</button>
            </nav>
            <a
                href="#"
                onClick={handleDownloadClick}
                className="px-4 py-2 bg-[#4F46E5] text-white rounded-full text-sm font-semibold hover:bg-indigo-700 transition duration-300 shadow-lg shadow-indigo-300/50"
            >
                Download Now
            </a>
        </div>
    </header>
);

export default Header;